import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import VideoIcon from '~/components/SVG/Video.svg?react';

const styles: { icon: SxProps<Theme> } = {
  icon: (theme: Theme) => ({
    width: '60px',
    height: '60px',
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px',
    },
  }),
};

const Video = () => {
  return <Box component={VideoIcon} sx={styles.icon} />;
};

export default Video;
